import React, { useEffect } from "react";

import UserInterface from "ui/UserInterface";
import Connectivity from "connectivity/Connectivity";
import Wss from "connectivity/Wss";
import FCM from "connectivity/FCM";
import Database from "data/Database";
import GlobalStateProvider from "contexts/GlobalStateProvider";
import DatabaseStateProvider from "data/DatabaseStateProvider";
import WebsocketStateProvider from "connectivity/WebsocketStateProvider";
import LocationStateProvider from "geospatial/LocationStateProvider";
import Location from "geospatial/Location";

const App = (props) => {
  // Anything here acts as componentWillMount

  useEffect(() => {
    // This runs after component is rendered ... every time
    console.log("App component rendered");
  });

  useEffect(() => {
    // This runs after component is rendered ... first time. The [] indicates "no dependencies"
    // so this is like componentDidMount
    console.log("App component is rendered ... first time");
    return () => {
      console.log("App component runs componentWillUnmount for the last time");
    };
  }, []);

  useEffect(() => {
    // this is like componentDidUpdate
    console.log("App componentDidUpdate because props changed");

    return () => {
      // this is like componentWillUnmount
      console.log("App componentWillUnmount because props changed");
    };
  }, [props]);

  let content = (
    <GlobalStateProvider>
      <DatabaseStateProvider>
        <LocationStateProvider>
          <WebsocketStateProvider>
            <Connectivity
              poll_interval={15000}
              poll_address="https://www.google.com"
            />
            <Location poll_interval={300000} />
            <Wss url="wss://wss1.reaches.me:8443/websocket" />
            <Database
              dbUrl="dbMaster" /* This is the application's master database with a list of databases */
              dbUser="dbUser"
            />
            <FCM />
            <UserInterface />
          </WebsocketStateProvider>
        </LocationStateProvider>
      </DatabaseStateProvider>
    </GlobalStateProvider>
  );

  return content;
};

export default App;
